import { render, staticRenderFns } from "./Url.vue?vue&type=template&id=248d4d2f&scoped=true"
import script from "./Url.vue?vue&type=script&lang=js"
export * from "./Url.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d4d2f",
  null
  
)

export default component.exports